import React from 'react';
import Header from './Header';
import About from '../sections/About';
import Experience from '../sections/Experience';
import Contact from '../sections/Contact';
import BackgroundAnimation from './BackgroundAnimation';
import ScrollIndicator from './ScrollIndicator';
import '../../styles/components/Layout.css';

const Layout = () => {
  return (
    <>
      <BackgroundAnimation />
      <Header />
      <div className="container">
        <About />
        <Experience />
        <Contact />
      </div>
      <ScrollIndicator />
    </>
  );
};

export default Layout; 